<template>
    <div
        id="app"
        v-if="isSecurityLoaded"
    >
        <header-wrapper />
        <navbar />
        <router-view />
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import HeaderWrapper from '@/components/header/header.vue';
import Navbar from '@/components/navbar/navbar.vue';
import Snackbar from '@/components/snackbar/snackbar.vue';
import Loader from '@/components/loader/loader.vue';
import {APP_SCOPE, sdk} from '@/utils/sdk';
import './main.scss';

@Component({
    name: 'app',
    components: {
        HeaderWrapper,
        Navbar,
        Snackbar,
        Loader,
    },
})
export default class App extends Vue {
    private isSecurityLoaded = false;

    private async mounted(): Promise<void> {
        await this.setupCoodeSdk();
    }

    private async setupCoodeSdk(): Promise<void> {
        await sdk.auth.loadAuthModule()
        sdk.backend.request.api.setBaseUrl(process.env.VUE_APP_API_BASE_URL as string)
        sdk.backend.request.api.setTokenCallback(async () => sdk.auth.getToken(APP_SCOPE))

        const isSignedIn = sdk.auth.isAuthenticated()

        if (isSignedIn) {
            const useCaseId = Number(process.env.VUE_APP_USE_CASE_ID);
            await sdk.core.userAccessManagement.setPermissions(useCaseId)
            this.isSecurityLoaded = true;
        }
    }
}
</script>

<style lang="scss">
</style>
